export default __webpack_public_path__ + "static/media/HelpCenterImage.fa4c3b4e.svg";